// The following is a hook that exposes the methods and states of a smart alert box 
//That can be used as alert box for yes or no functionalities, ok only button and can also 
//mimic a toast, by simply not showing any buttons at all.

import { useCallback, useMemo, useState } from "react";
import AlertBox from "../Components/ui/AlertBox";

export interface AlertContentProps {
  isError: boolean;
  title: string;
  message: string; 
  isTwoButtons: boolean;
  onOk?: () => void;
  onYes?: () => void;
  showButton?: boolean;
}

export const useAlert = () => {
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertContent, setAlertContent] = useState<AlertContentProps>({
    isError: false,
    title: "",
    message: "",
    isTwoButtons: false,
    onOk: undefined,
    onYes: undefined,
    showButton: true,
  });


  const showAlert = useCallback((
    isError: boolean,
    title: string,
    message: string,
    isTwoButtons: boolean,
    onOk?: () => void,
    onYes?: () => void,
    showButton?: boolean,
  ): Promise<boolean> => {
    return new Promise((resolve) => {

      const handleOk = () => {
          resolve(true);
          // console.log("OK clicked, resolving Promise...");
          if(onOk) onOk();
          setAlertVisible(false); // Close alert
        };

      const handleYes = () => {
          // console.log("onYes clicked, executing callback...");
          if (onYes) onYes(); // Execute yes callback if provided
            resolve(true);
            setAlertVisible(false); // Close alert
        };

      setAlertContent({
        isError,
        title,
        message,
        isTwoButtons,
        onOk: handleOk,
        onYes:  handleYes,
        showButton,
      });
      setAlertVisible(true); // Show the alert
    });
  }, []);

  //this can manually be called to close the alert, or simply rely on default set for the onOK and onYes whe they resolve
  const closeAlert = useCallback(() => {
    setAlertVisible(false);
  }, []);

    const AlertComponent = useMemo(() => {
    return alertVisible ? (
      <AlertBox
        isError={alertContent.isError}
        alertTitle={alertContent.title}
        message={alertContent.message}
        onClose={closeAlert}
        isTwoButtons={alertContent.isTwoButtons}
        onOk={alertContent.onOk}
        onYes={alertContent.onYes}
        showButton={alertContent.showButton}
      />
    ) : null;
  }, [alertVisible, alertContent, closeAlert]);


  return { showAlert, closeAlert, AlertComponent };
};


